export default ({ totalInventory, productVariants = [] }) => {
  if (totalInventory > 0) return totalInventory

  const totalVariantsInventory = productVariants.reduce(
    (acc, { inventoryQuantity }) => acc + inventoryQuantity,
    0
  )

  if (totalVariantsInventory < 0) return 0

  return totalVariantsInventory
}
